import { render, staticRenderFns } from "./contact-single-quotes.vue?vue&type=template&id=35f5f692&"
import script from "./contact-single-quotes.vue?vue&type=script&lang=js&"
export * from "./contact-single-quotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports